import { CHANGE_PASSWORD_REQUEST, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE } from '../../constants'

const defaultState = {
  pending: false,
  changeFailure: false,
  error: {}
}

export default (state = defaultState, action) => {

  var newState = {...state}

  switch (action.type){
    case CHANGE_PASSWORD_REQUEST:
      newState.pending = true;
      newState.changeFailure = false;
      return newState;

    case CHANGE_PASSWORD_SUCCESS:
      newState.pending = false;
      newState.changeFailure = false;
      return newState;

    case CHANGE_PASSWORD_FAILURE:
      newState.pending = false;
      newState.changeFailure = true;
      newState.error = action.error;
      return newState;

    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/password/change.js